import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=4f696f0c&scoped=true&"
import script from "./AIChat.vue?vue&type=script&lang=js&"
export * from "./AIChat.vue?vue&type=script&lang=js&"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=4f696f0c&prod&lang=less&scoped=true&"
import style1 from "./AIChat.vue?vue&type=style&index=1&id=4f696f0c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f696f0c",
  null
  
)

export default component.exports